<template>
  <div>
    <div class="text-lg font-bold text-gray-500">
      <slot />
    </div>
    <div class="text-sm text-gray-500">
      <slot name="subtitle" />
    </div>
  </div>
</template>
